import React, { useEffect, useMemo, useState, useRef } from "react";

import $ from "jquery";
import moment from "moment";
import "daterangepicker";
import "daterangepicker/daterangepicker.css";
import { api } from "../../../utils/api";
import { useLoaderStore } from "../../../store/loaderStore";

import {
  FiSearch,
  FiClock,
  FiCalendar,
} from "react-icons/fi";
import { toast } from "react-toastify";

import "./Myapproval.css";
import ApprovalPunchSummary, { approvalInitials } from "../../../components/mobile/ApprovalPunchSummary";
import "../../../components/mobile/ApprovalPages.css";
import RequestDetailsSheet from "../../../components/mobile/RequestDetailsSheet";
import "../../../components/mobile/MobileDatePicker.css";
import { alignPickerToFilter } from "../../../utils/mobileDatePicker";
import MobileLayout from "../../../layouts/MobileLayout";
import { useAuthStore } from "../../../store/authStore";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

const Myapproval = () => {
  /*
  =====================================================
  AUTH
  Use EXACTLY the same authentication logic
  as Pending Approvals
  =====================================================
  */

  const { user, isAuthenticated } = useAuthStore();
  const companyId = user?.company_id;

  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(false);
  const { showLoader, hideLoader } = useLoaderStore();

  useEffect(() => {
    if (!loading) return undefined;

    showLoader("master");
    return () => hideLoader();
  }, [loading, showLoader, hideLoader]);

  const [error, setError] = useState("");

  const [search, setSearch] = useState("");
  const [statusFilter, setStatusFilter] = useState("");

  const [modalOpen, setModalOpen] = useState(false);
  const [selectedApproval, setSelectedApproval] = useState(null);

  const pickerRef = useRef(null);

  const [startDate, setStartDate] = useState(
    moment().startOf("month").format("YYYY-MM-DD"),
  );

  const [endDate, setEndDate] = useState(
    moment().endOf("month").format("YYYY-MM-DD"),
  );

  /*
  =====================================================
  FORMAT DATE
  =====================================================
  */

  const formatDate = (dateTime) => {
    if (!dateTime) return "-";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleDateString("en-GB", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  };

  /*
  =====================================================
  FORMAT TIME
  =====================================================
  */

  const formatTime = (dateTime) => {
    if (!dateTime) return "-";

    const date = new Date(dateTime);

    if (Number.isNaN(date.getTime())) {
      return "-";
    }

    return date.toLocaleTimeString("en-GB", {
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    });
  };

  /*
  =====================================================
  FORMAT API DATE
  YYYY-MM-DD
  =====================================================
  */

  const formatApiDate = (date) => {
    const year = date.getFullYear();

    const month = String(date.getMonth() + 1).padStart(2, "0");

    const day = String(date.getDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  };

  /*
  =====================================================
  FETCH MY APPROVAL REQUESTS
  =====================================================
  */

  // const fetchMyApprovals = async (fromDate = startDate, toDate = endDate) => {
  //   if (!token || !companyId) {
  //     console.log("My Approvals: token or company_id not found.");
  //     return;
  //   }

  //   try {
  //     setLoading(true);
  //     setError("");

  //     const params = new URLSearchParams({
  //       company_id: companyId,
  //       from_date: fromDate,
  //       to_date: toDate,
  //     });

  //     const url = `${API_BASE_URL}/attendance/missing-punch/my-requests?${params.toString()}`;

  //     console.log("My Approvals API URL:", url);

  //     const response = await fetch(url, {
  //       method: "GET",
  //       headers: {
  //         Accept: "application/json",
  //         Authorization: `Bearer ${token}`,
  //       },
  //     });

  //     const result = await response.json();

  //     console.log("My Approvals API Response:", result);

  //     if (!response.ok || !result.status) {
  //       throw new Error(
  //         result.message ||
  //           result.detail ||
  //           "Failed to fetch your approval requests.",
  //       );
  //     }

  //     setApprovals(Array.isArray(result.data) ? result.data : []);
  //   } catch (err) {
  //     console.error("Fetch my approvals error:", err);

  //     setApprovals([]);

  //     const errorMessage =
  //       err?.message || "Failed to load your approval requests.";

  //     setError(errorMessage);

  //     toast.error(errorMessage);
  //   } finally {
  //     setLoading(false);
  //   }
  // };


  const fetchMyApprovals = async (fromDate = startDate, toDate = endDate) => {
  if (!isAuthenticated || !companyId) {
    console.log("My Approvals: token or company_id not found.");
    return;
  }

  try {
    setLoading(true);
    setError("");

    const params = new URLSearchParams({
      company_id: companyId,
      from_date: fromDate,
      to_date: toDate,
    });

    console.log(
      "My Approvals API:",
      `/attendance/missing-punch/my-requests?${params.toString()}`
    );

    const response = await api.get(
      `/attendance/missing-punch/my-requests?${params.toString()}`,
      {
        headers: {
          Accept: "application/json",
        },
      }
    );

    const result = await response.json();

    console.log("My Approvals API Response:", result);

    if (!result.status) {
      throw new Error(
        result.message ||
          result.detail ||
          "Failed to fetch your approval requests."
      );
    }

    setApprovals(Array.isArray(result.data) ? result.data : []);
  } catch (err) {
    console.error("Fetch my approvals error:", err);

    setApprovals([]);

    const errorMessage =
      err?.message || "Failed to load your approval requests.";

    setError(errorMessage);

    toast.error(errorMessage);
  } finally {
    setLoading(false);
  }
};

  /*
  =====================================================
  FETCH WHEN TOKEN IS AVAILABLE
  =====================================================
  */
  useEffect(() => {
    if (isAuthenticated && companyId) {
      fetchMyApprovals();
    }
  }, [isAuthenticated, companyId]);

  useEffect(() => {
    if (!pickerRef.current) return;

    const $picker = $(pickerRef.current);

    if ($picker.data("daterangepicker")) {
      $picker.data("daterangepicker").remove();
    }

    const cb = (start, end) => {
      const from = start.format("YYYY-MM-DD");
      const to = end.format("YYYY-MM-DD");

      setStartDate(from);
      setEndDate(to);

      fetchMyApprovals(from, to);
    };

    $picker.daterangepicker(
      {
        startDate: moment(startDate),
        endDate: moment(endDate),

        autoUpdateInput: false,
        showDropdowns: true,
        linkedCalendars: false,
        alwaysShowCalendars: true,

        opens: "left",

        ranges: {
          Today: [moment(), moment()],

          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],

          "Last 7 Days": [moment().subtract(6, "days"), moment()],

          "Last 30 Days": [moment().subtract(29, "days"), moment()],

          "This Month": [moment().startOf("month"), moment().endOf("month")],

          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      cb,
    );

    const picker = $picker.data("daterangepicker");
    picker.container.addClass("mobile-daterangepicker");
    const unalign = alignPickerToFilter(
      picker,
      pickerRef.current,
      pickerRef.current.closest(".my-approval-filter-bar"),
    );

    return () => {
      unalign();
      if ($picker.data("daterangepicker")) {
        $picker.data("daterangepicker").remove();
      }
    };
  }, []);
  /*
  =====================================================
  STATUS
  =====================================================
  */

  const getStatus = (approval) => {
    return approval?.status || "Pending";
  };

  /*
  =====================================================
  SEARCH + STATUS FILTER
  =====================================================
  */

  const filteredApprovals = useMemo(() => {
    const searchValue = search.trim().toLowerCase();

    return approvals.filter((approval) => {
      const status = getStatus(approval);

      /*
      STATUS
      */

      const matchesStatus =
        !statusFilter ||
        String(status).toLowerCase() === statusFilter.toLowerCase();

      /*
      SEARCH
      */

      const searchableText = [
        approval?.id,
        approval?.user_id,
        approval?.employee_code,
        approval?.in_datetime,
        approval?.out_datetime,
        approval?.status,
        approval?.remark,
        approval?.created_at,
      ]
        .filter((value) => value !== null && value !== undefined)
        .join(" ")
        .toLowerCase();

      const matchesSearch =
        !searchValue || searchableText.includes(searchValue);

      return matchesStatus && matchesSearch;
    });
  }, [approvals, search, statusFilter]);

  /*
  =====================================================
  OPEN DETAILS
  =====================================================
  */

  const openDetails = (approval) => {
    setSelectedApproval(approval);
    setModalOpen(true);
  };

  /*
  =====================================================
  CLOSE MODAL
  =====================================================
  */

  const closeModal = () => {
    setModalOpen(false);
    setSelectedApproval(null);
  };

  /*
  =====================================================
  DURATION
  =====================================================
  */

  const getDuration = (inDateTime, outDateTime) => {
    if (!inDateTime || !outDateTime) {
      return "-";
    }

    const start = new Date(inDateTime);

    const end = new Date(outDateTime);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) {
      return "-";
    }

    const difference = end.getTime() - start.getTime();

    if (difference < 0) {
      return "-";
    }

    const totalMinutes = Math.floor(difference / 60000);

    const hours = Math.floor(totalMinutes / 60);

    const minutes = totalMinutes % 60;

    return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
      2,
      "0",
    )}`;
  };

  /*
  =====================================================
  RENDER
  =====================================================
  */

  return (
    <MobileLayout>
      <div className={`my-approval-page approval-design ${!loading && filteredApprovals.length === 0 ? "approval-no-results" : ""}`}>
        {/* =================================================
          HEADER
      ================================================= */}

        <div className="my-approval-header">
          <h1 className="my-approval-title">My Requests</h1>

          <p className="my-approval-summary">
            {filteredApprovals.length}/{approvals.length} Requests
          </p>
        </div>

        {/* =================================================
          FILTER
      ================================================= */}

        {/* =================================================
          FILTER
        ================================================= */}

        <div className="my-approval-filter-bar">
          <div className="my-approval-filter-group">
            <label className="my-approval-filter-label">Date</label>

            <div className="my-approval-search-row">
              {/* SEARCH */}

              {/* <div className="my-approval-search-wrapper">
                <FiSearch className="my-approval-search-icon" />

                <input
                  type="text"
                  className="my-approval-filter-input"
                  placeholder="Search requests"
                  value={search}
                  onChange={(e) => setSearch(e.target.value)}
                />
              </div> */}

              {/* DATE RANGE */}

              <button type="button" ref={pickerRef} className="my-approval-date-range" aria-label="Choose date range">
                <span>
                  {moment(startDate).format("DD MMM")} -{" "}
                  {moment(endDate).format("DD MMM")}
                </span>

                <span className="my-approval-calendar-icon">
                  <FiCalendar />
                </span>
              </button>
            </div>
          </div>

          {/* STATUS */}

          <div className="my-approval-filter-group">
            <label className="my-approval-filter-label">Status</label>

            <select
              className="my-approval-filter-select"
              value={statusFilter}
              onChange={(e) => setStatusFilter(e.target.value)}
            >
              <option value="">All</option>
              <option value="Pending">Pending</option>
              <option value="Approved">Approved</option>
              <option value="Rejected">Rejected</option>
            </select>
          </div>
        </div>

        {/* =================================================
          ERROR
      ================================================= */}

        {error && <div className="my-approval-error">{error}</div>}

        {/* =================================================
          CONTENT
      ================================================= */}

        <div className="my-approval-content">
          {/* EMPTY */}

          {!loading && filteredApprovals.length === 0 && (
            <div className="my-approval-empty">
              <div className="my-approval-empty-icon">
                <FiClock />
              </div>

              <h3 className="my-approval-empty-title">No Approval Requests</h3>

              <p className="my-approval-empty-text">
                You don't have any approval requests for this period.
              </p>
            </div>
          )}

          {/* LIST */}

          {!loading && filteredApprovals.length > 0 && (
            <div className="my-approval-list">
              {filteredApprovals.map((approval) => {
                const status = getStatus(approval);

                return (
                  <div key={approval.id} className="my-approval-card">
                    {/* CARD TOP */}

                    <div className="my-approval-card-top">
                      <div className="my-approval-card-left">
                        <div className="my-approval-user-icon" aria-hidden="true">
                          {approvalInitials(approval.user_name || user?.name || user?.user_name)}
                        </div>

                        <div className="my-approval-user-info">
                          <h3 className="my-approval-user-name">
                            {approval.user_name || user?.name || user?.user_name || "Employee"}
                          </h3>

                          <p className="my-approval-user-code">
                            Request #{approval.id}
                          </p>
                        </div>
                      </div>

                      {/* STATUS */}

                      <span
                        className={`my-approval-status ${
                          status === "Approved"
                            ? "my-approval-status-approved"
                            : status === "Rejected"
                              ? "my-approval-status-rejected"
                              : "my-approval-status-pending"
                        }`}
                      >
                        {status}
                      </span>
                    </div>

                    {/* DETAILS */}

                    <ApprovalPunchSummary
                      inDateTime={approval.in_datetime}
                      outDateTime={approval.out_datetime}
                    />

                    {/* REQUEST INFO + VIEW */}

                    <div className="my-approval-actions">
                      <div className="my-approval-request-info-item">
                        <FiClock />

                        <span>
                          Requested on {formatDate(approval.created_at)}
                        </span>
                      </div>

                      <button
                        type="button"
                        className="my-approval-view-btn"
                        onClick={() => openDetails(approval)}
                      >
                        View
                      </button>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
        </div>

        {/* =================================================
          DETAIL MODAL
      ================================================= */}

        {modalOpen && selectedApproval && (
          <RequestDetailsSheet
            request={selectedApproval}
            onClose={closeModal}
            formatDate={formatDate}
            formatTime={formatTime}
            getDuration={getDuration}
          />
        )}
      </div>
    </MobileLayout>
  );
};

export default Myapproval;
